'use strict';

import intlTelInput from 'intl-tel-input';

const input = document.querySelector("#registration-form-phone");
if (input) {
    intlTelInput(input, {
        initialCountry: "it",
        separateDialCode: true,
        loadUtils: () => import("intl-tel-input/build/js/utils.js"),
    });

    input.addEventListener("input", function () {
        this.value = this.value.replace(/[^\d+]/g, "");

        if (this.value.length > 15) {
            this.value = this.value.slice(0, 15);
        }
    });
}

$(document).ready(function() {
    if($('.pd-catalog-grid').length){

        $('#catalogCartModal').on('show.bs.modal', function () {
            $('body').css('overflow', 'auto');
        });
        $('#catalogCartModal').on('hidden.bs.modal', function () {
            $('body').css('overflow', 'auto');
        });
        $('#catalogOrderResultModal').on('hidden.bs.modal', function (e) {
            $('#orderCatalog-form').modal('hide');
        });
        
        $('.pd-catalog-grid').on('click', 'button.order-catalog', function(e) {
            e.preventDefault();
            var catalog = $(this);
            addOrRemoveCatalog(catalog.data('catalog-id'), catalog.data('catalog-title'));
        });

        $(document).on('click', 'button.closeOrderResult', function(e) {
            e.preventDefault();
            $('.catalog-added').each(function(c) {
                $(this).text("Richiedi la tua copia gratuita").removeClass('catalog-added');
            });
            $("#orderCatalog-form").modal('hide');
            $("#orderCatalogResult").modal('hide');
            checkAddedCatalogs();
        });
        $(document).on('click', '.catalog-cart-item', function(e) {
            e.preventDefault();
            var catalog = $(this);
            addOrRemoveCatalog(catalog.data('catalog-id'), catalog.data('catalog-title'));
        });

        $('#CatalogOrderForm').on('submit', function(e) {
            e.preventDefault();
            $.spinner().start();
            const $form = $('#CatalogOrderForm');
            $('#registration-form-phone').val($('.iti__selected-dial-code').text() + ' ' + $('#registration-form-phone').val())
            $.ajax({
                url: $form.attr('action'),
                type: 'post',
                contentType: "application/json",
                data: $form.serialize(),
                success: function (data) {
                    $.spinner().stop();
                    $("#orderCatalogResult").html('');
                    $("#orderCatalogResult").html(data);
                    $("#orderCatalogResult").modal('show');
                    $('#CatalogOrderForm')[0].reset();
                },
                error: function (err) {
                    $.spinner().stop();
                    $("#orderCatalogResult").modal('show');
                    $('#CatalogOrderForm')[0].reset();
                }
            });
        });

        $('input[name="dwfrm_catalogOrder_privacy"]').on('change', function() {
            var $submitBtn = $('.orderCatalog-submit.buttonSubmit');
            var isChecked = $('#catalogPrivacy-true:checked').length > 0;
            $submitBtn.prop('disabled', !isChecked);
        });

        if($('#catalogPrivacy-true:checked').length > 0){
            $('.orderCatalog-submit.buttonSubmit').prop('disabled', false);
        }

        if(!$('button.order-catalog').length){
            $('#catalogCartModal').hide();
        } else {
            checkAddedCatalogs();
        }
    }
});

function addOrRemoveCatalog(catID, catTitle) {
    $.ajax({
        url: $('#addOrRemoveCatalogUrl').val(),
        type: 'POST',
        dataType: 'json',
        data: {
            catID : catID,
            catTitle : catTitle
        },
        success: function (data) {
            if(data.action === 'add'){
                var catalogLabel = $('#' + catID);
                catalogLabel.toggleClass('catalog-added');
                catalogLabel.text("Rimuovi dalla richiesta");
            }
            else if(data.action === 'remove'){
                var catalogLabel = $('#' + catID);
                catalogLabel.toggleClass('catalog-added');
                catalogLabel.text("Richiedi la tua copia gratuita");
            }
            else if(data.action === 'nothing'){
                $('.error-max-catalogs').show();
                setTimeout(function () {
                    $('.error-max-catalogs').hide();
                }, 5000);
            }
            triggerOrderModal(data.catalogs);
        },
        error: function (err) {
        }
    });
}

function checkAddedCatalogs() {

    $.ajax({
        url: $('#getCatalogsUrl').val(),
        type: 'GET',
        dataType: 'json',
        success: function (data) {
            if(data.catalogs){
                var cats = data.catalogs;
                cats.forEach(function(c) {
                    var catalogLabel = $('#' + c.catID.toString());
                    catalogLabel.toggleClass('catalog-added');
                    catalogLabel.text("Rimuovi dalla richiesta");
                });
                triggerOrderModal(cats);
            }
            else {
                triggerOrderModal([]);
            }
        },
        error: function (err) {
        }
    });
}

function triggerOrderModal(addedCatalogs){
    if(addedCatalogs.length == 0){
        $('.selected-catalogs').html('');
        $('.selected-catalogs').html('<p class="no-catalogs">Aggiungi almeno un catalogo</p>');
        $('#wrapper-invia-ordine').hide();
    } else {
        var modalBody = '';
        addedCatalogs.forEach(function(c) {
            modalBody += ('<p title="Rimuovi dalla richiesta" class="catalog-cart-item" data-catalog-id="' + c.catID + '" data-catalog-title="' + c.catTitle + '">' + c.catTitle + "</p>");
        });
        $('.selected-catalogs').html('');
        $('.selected-catalogs').html(modalBody);
        $('#wrapper-invia-ordine').show();
    }
}

